import { styled } from "@mui/material/styles";
import { Typography, Box } from "@mui/material";
import { List, ListSubheader, ListItem } from "@mui/material";

export const PageBox = styled((props: any) => <Box {...props} />)(
  ({ theme }) => ({
    marginLeft: theme.spacer_n,
    marginRight: theme.spacer_n,
    [theme.breakpoints.up("sm")]: {
      marginLeft: 0,
      marginRight: 0
    }
  })
);

export const MainLeftContent = styled("div")(({ theme }) => ({
  display: "inline-flex",
  alignItems: "center",

  "& .logo-wrapper": {
    position: "absolute",
    left: "-2rem",
    top: "8rem",
    width: "8rem",
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "block"
    }
  }
}));

export const MainRightContent = styled("div")(({ theme }) => ({
  [theme.breakpoints.up("md")]: {
    paddingLeft: "41.5rem"
  },
  [theme.breakpoints.up("xl")]: {
    paddingLeft: "0"
  }
}));

export const HomeHeader = styled((props: any) => <Typography {...props} />)(
  ({ theme }) => ({
    fontSize: "2em",
    fontWeight: "bold",
    marginBottom: theme.spacer_m
  })
);

export const HomeList = styled((props: any) => <List {...props} />)(
  ({ theme }) => ({
    listStyleType: "disc",
    padding: "0"
  })
);

export const HomeListSubheader = styled((props: any) => (
  <ListSubheader {...props} />
))(({ theme }) => ({
  fontSize: "1.5rem",
  color: theme.palette.black.main,
  padding: "0"
}));

export const HomeListItem = styled((props: any) => <ListItem {...props} />)(
  ({ theme }) => ({
    listStyleType: "disc",
    fontSize: "1.5rem",
    marginLeft: "30px",
    padding: "0"
  })
);
